module.exports = __webpack_public_path__ + "img/introduction_media_03.efb064cd.jpg";